export const css = {
    root: '_1EHLRNbb',
    underlayVisible: 'ArceXGTT',
    pane: '_1bSbK4IN',
    open: '_3SMPY3X4',
    content: '_1IFp8FTU',
    title: '_15zozGcu',
    close: '_2VdzMB5Q',
    closeIcon: '_38yKeqzv',
    left: '_15D6JNI0',
    right: '_2B-4A6JD',
    top: '_2YMft6A4',
    bottom: '_2AKwb2cI',
    slideIn: '_2Lp8d603',
    slideOut: '_2OjVjcff',
    ' _key': 'certwise-theme/dojo/slide-pane'
};
export default css;
